import {Route, Routes} from 'react-router-dom';

import {List} from './List';

export default function EmailTemplate() {

  return (
    <Routes>
      <Route path="/" element={<List/>}/>
    </Routes>
  );
}
